<template>
  <div>
    <h3 class="mb-3">Create a webhook</h3>
    <p class="text-muted mb-4">
      Configure the URL where the <a href="https://docs.amio.io/v1.0/reference#webhooks">Webhooks</a> need to be sent to.
    </p>
    <button type="button" class="btn btn-primary" @click="$emit('click')">
      <icon class="btn-icon" name="plus-circle" scale="0.9"/>
      Create Webhook
    </button>
  </div>
</template>

<script>

  export default {
    name: 'EmptyWebhookView'
  }
</script>
